<template>
  <div class="headnav">
    <img class="logo" src="/static/img/navlogo.png" alt="" />
    <div class="navitem">
      <div class="item" :class="routerindex == item.rou ? 'sel' : ''" v-for="(item, index) in navarr" :key="index"
        @click="clickE(item, index)" @mouseenter="mouseenterE(index)">
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="floatbox" v-show="navindex == 1" @mouseenter="FmouseenterE" @mouseleave="mouseleaveE">
      <div class="floatitem  " v-for="(item, index) in S.present" :key="index" @click="toserE(index)">
        <img :src="item.image2" alt="" />
        <span>{{ item.big_title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import text from "../../static/data/text";
export default {
  data() {
    return {
      lan: "cn",
      routerindex: "home",
      isfloat: false,
      navindex: 0,
      navarr: [
        { name: "首页", rou: "home" },
        { name: "服务", rou: "services" },
        { name: "关于我们", rou: "about" }
      ]
    };
  },

  watch: {
    $route: {
      handler(newV, oldV) {
        this.routerindex = this.$route.name;
      },
      immediate: true
    }
  },
  computed: {
    S() {
      return text[this.lan]["service"];
    }
  },
  methods: {
    toserE(index) {
      this.$router.push({ path: "/services", query: { num: index } });
    },
    clickE(item, index) {
      this.routerindex = item.rou;
      if (index != 1) {
        this.$router.push({ path: `/${item.rou}` });
      } else {
        this.toserE(0);
      }
    },
    mouseenterE(index) {
      this.navindex = index;
    },

    FmouseenterE() {
      this.navindex = 1;
    },
    mouseleaveE() {
      this.navindex = -1;
    }
  }
};
</script>
<style scoped>
.headnav {
  background: #174197;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #ffff;
}

.headnav .logo {
  height: 82px;
  margin-left: 287px;
  margin-right: 807px;
  padding-top: 11px;
  padding-bottom: 13px;
  cursor: pointer;
}

.navitem {
  display: flex;
}

.navitem .item {
  cursor: pointer;
  margin-right: 50px;
  display: flex;
  align-items: center;
  height: 105px;

  box-sizing: border-box;
  /* transition: all 1.2s; */
}

.navitem .item:hover span {
  transform: scale(1.1);
  color: #255dcc;
}

.sel {
  border-bottom: 3px solid #255dcc;
  /* color: #255dcc; */
}

.floatbox {
  /* width: 1920px; */
  left: 0;
  right: 0;
  height: 460px;
  /* background: rgb(0, 0, 0, 0.05); */
  /* opacity: 0.2; */
  position: absolute;
  bottom: -460px;
  box-sizing: border-box;
  padding-top: 6px;
  padding-bottom: 13px;
  padding-left: 145px;
  padding-right: 145px;
  display: flex;
}

.floatitem {
  cursor: pointer;
  font-size: 28px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  position: relative;
  border: 1px dashed #666;
}

.floatitem:hover::before,
.selitem::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #000;
  opacity: 0;
}

.floatitem::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #000;
  opacity: 0.5;
}

.floatitem img {
  height: 439px;
}

.floatitem span {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  text-align: center;
  bottom: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/headnav.vue